module.exports = __webpack_public_path__ + "img/horizontal-placeholder.5254f495.svg";